const apiurl = 'https://ats.steelobpo.com/api/'

export const appSettings = {
  apiurl: apiurl,
  authurl: apiurl + '/oauth/token',
  logouturl: apiurl + '/logout',
  defaultLoginRequest: {
    client_id: '82',
    client_secret: 'QkCRjSmbXov22Jx31Vtyn1nqasCYD06VosITzodr',
    grant_type: 'password',
    scope: '*',
    username: '',
    password: ''
  },
  logos: {
    loginTop: 'static/Logo_dytnet.png',
    loginLogo: 'CustomModules/GlobalBPOCore/assets/logo_fpt.png',
    menuLogo: 'static/Logo_dytnet.png',
    globalLoginLogo: 'logo_fpt.png'
  },
  title: 'STEELO APP',
  recaptcha: {
    enabled: true,
    site_key: '6LfeHYMdAAAAAIU0mSW5xvjd9rpOYcqDRjuGlfMK',
    loaderOptions: {
      explicitRenderParameters: {
        badge: 'bottomleft'
      }
    }
  },
 login: {
    video: 'video steel.mp4',
    logo: 'logo_ats.png',
    message: 'Steel`O App',
    loginFirstColor: '#51c1e1', /* #93d22f */
    loginTextColor: '#FFFFFF',
    loginTransparency: 0.5
  },
  customDashboardBg: '#28353a !important',
  baseWebTitle: 'Ats'
}




// WEBPACK FOOTER //
// ./src/store/app_settings.js